<template>
	<canvas ref='canvas' :width='width' :height='height' />
</template>

<script>
	import * as d3 from "d3";

	export default {
		name: "MapPaths",
		props: {
			mapping: {},
			width: '',
			height: ''
		},
		data() {
			return {
				geojson: {
					features: [],
				},
			};
		},
		mounted() {
			this.drawMap();
		},

		updated() {
			this.drawMap();
		},

		methods: {
			getPaths(country) {
				return d3.geoPath().projection(this.mapping.projection)(country);
			},
			drawMap() {
				this.geojson = d3.json("map.medium.json").then(data => {
					const context = this.$refs.canvas.getContext("2d");
					const projection = d3.geoPath().projection(this.mapping.projection);

					context.strokeWidth = '1px';
					context.strokeStyle = '#49496f';
					context.fillStyle = '#2c2c43';

					data.features.forEach(country => {
						const proj = projection(country);
						const path = new Path2D(proj);
						context.stroke(path);
						context.fill(path);
						context.closePath();
					});
				});
			}
		},
	}
</script>

<style scoped>
	path {
		stroke: #49496f;
		stroke-width: 1;
		fill: #2c2c43;
	}
</style>